<template>
  <label class="flex items-center cursor-pointer">
    <span class="flex items-center">
      <input
        type="checkbox"
        :checked="checked"
        @change="onChange"
      >

      <span
        class="box"
        :class="{bright: brightTick}"
      />
    </span>
    <slot />
  </label>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: () => false,
    },
    brightTick: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onChange(event) {
      this.$emit('input', event.target.checked);
    },
  },
};
</script>

<style scoped>
input {
  opacity: 0;
  width: 0;
  height: 0;
}
.box {
  width: 18px;
  height: 18px;
  position: relative;
  @apply border border-primary-purple rounded;
}
input:checked + .box {
  border: none;
  @apply bg-primary-purple;
}
input:checked + .box::before {
  content: "";
  display: inline-block;
  border-right: 2px solid #171717;
  border-bottom: 2px solid #171717;
  width: 4px;
  height: 8px;
  transform: rotate(45deg);
  top: 5px;
  left: 7px;
  transition: all 0.3s;
  position: absolute;
}
input:checked + .box.bright::before {
    border-right-color: white;
    border-bottom-color: white;
}
@screen lg {
  .box {
    width: 15px;
    height: 15px;
  }
  input:checked + .box::before  {
    top: 3px;
    left: 5px;
  }
}
</style>
